import React from "react";
import styles from "./BetTableTeen.module.css";

export default function BetTableTeen({ data = [], exposures = {}, min = "10.0", max = "100K" }) {
  // Parse data to extract Player A/B Main (subtype: "teen", etype: "match")
  const playerAMain = data.find(item => item.nat === "Player A" && item.subtype === "teen" && item.etype === "match") || {};
  const playerBMain = data.find(item => item.nat === "Player B" && item.subtype === "teen" && item.etype === "match") || {};

  // Helper to get exposure
  const getExposure = (selection) => {
    if (!selection) return 0;

    const exposureKeys = [
      selection,
      selection.toLowerCase(),
      selection.trim(),
      selection.toLowerCase().trim(),
    ].filter(Boolean);

    for (const key of exposureKeys) {
      if (exposures[key] !== undefined && exposures[key] !== 0) {
        return parseFloat(exposures[key]) || 0;
      }
    }

    return 0;
  };

  // Check if bet is suspended (matching dragonTigerLion logic)
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined;
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (!value || value === 0) return "0";
    return value < 0 ? value.toFixed(0) : `+${value.toFixed(0)}`;
  };

  // Format number with K suffix
  const formatMax = (value) => {
    if (!value) return "0";
    const num = parseFloat(value);
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(0)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(0)}K`;
    }
    return num.toString();
  };

  // Render Player row
  const renderPlayerRow = (item, playerName) => {
    const backSuspended = isSuspended(item) || !item.b || item.b === 0 || item.b === null || item.b === undefined;
    const laySuspended = isSuspended(item) || !item.l || item.l === 0 || item.l === null || item.l === undefined;
    const rowSuspended = isSuspended(item);
    const bsValue = item.bs || 0;
    const lsValue = item.ls || 0;
    const minValue = item.min || 100;
    const maxValue = item.max || 500000;
    
    // Only apply suspended to cells if row is not suspended (to avoid duplicate lock icons)
    const backCellSuspended = rowSuspended ? "" : (backSuspended ? styles.suspended : "");
    const layCellSuspended = rowSuspended ? "" : (laySuspended ? styles.suspended : "");
    
    return (
      <tr className={rowSuspended ? styles.suspended : ""}>
        <td className={`${styles.box6} ${styles.playerName}`}>
          <b>{playerName}</b>
          <p className={styles.mb0}>
            <span style={{ color: '#fff' }}>{bsValue}</span>
            <span className={styles.floatRight} style={{ color: '#fff' }}>{lsValue}</span>
          </p>
        </td>
        <td className={`${styles.back} ${styles.textCenter} ${styles.box1} ${backCellSuspended}`}>
          <span className={`${styles.dBlock} ${styles.textBold}`}>{item.b || "0"}</span>
          <span tyle={{
            color: '#000',
            fontSize: '10px'
          }}>
            {bsValue || "0"}
          </span>
        </td>
        <td className={`${styles.lay} ${styles.textCenter} ${styles.box1} ${layCellSuspended}`}>
          <span className={`${styles.dBlock} ${styles.textBold}`}>{item.l || "0"}</span>
          <span style={{
            color: '#000',
            fontSize: '10px'
          }}>
            {lsValue || "0"}
          </span>
        </td>
        <td className={`${styles.textRight} ${styles.pr10} ${styles.box2}`}>
          <span className={styles.dBlock}>
            Min:<span>{minValue}</span>
          </span>
          <span className={styles.dBlock}>
            Max:<span>{formatMax(maxValue)}</span>
          </span>
        </td>
      </tr>
    );
  };

  return (
    <div className={styles.casinoDetail}>
      <div className={`table-responsive ${styles.mt5}`}>
        <table className={`table table-bordered ${styles.table}`}>
          <thead>
            <tr>
              <th className={styles.box6}></th>
              <th className={`${styles.back} ${styles.textCenter} ${styles.box1}`}>BACK</th>
              <th className={`${styles.lay} ${styles.textCenter} ${styles.box1}`}>LAY</th>
              <th className={`${styles.textCenter} ${styles.box2}`}></th>
            </tr>
          </thead>
          <tbody>
            {renderPlayerRow(playerAMain, "Player A")}
            {renderPlayerRow(playerBMain, "Player B")}
          </tbody>
        </table>
      </div>
    </div>
  );
}

